module.exports = __webpack_public_path__ + "img/x.0d531863.png";